import gql from 'graphql-tag';

const CAMPAIGN_LAUNCH_PROGRESS_SUBSCRIPTION = gql`
  subscription campaignLaunchProgress($campaignOrderId: ID!) {
    campaignLaunchProgress(campaignOrderId: $campaignOrderId) {
      campaignOrderId
      campaignId
      phase
      step
      progress
      total
      current
      message
      timestamp
      metadata {
        lineItemId
        lineItemName
        lineItemIndex
        totalLineItems
        creativeId
        creativeName
        creativeIndex
        totalCreatives
        errorDetails
        estimatedDuration
        complexityLevel
        possibleTimeout
      }
    }
  }
`;

export default CAMPAIGN_LAUNCH_PROGRESS_SUBSCRIPTION;